import { IRoomProps } from '@/entities/Room'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IRoomState {
  response: IResponseProps<IRoomProps>
  talk: IResponseProps<IRoomProps>
  current: IRoomProps | null
  top: IRoomProps | null
  scrollTop: number
  filter: string
  priority: string | null
}

export const state = (): IRoomState => ({
  response: EmptyResponsePropsFactory(),
  talk: EmptyResponsePropsFactory(),
  current: null,
  top: null,
  scrollTop: 0,
  filter: 'all',
  priority: null
})

export default state
